
import type { IconName } from 'components/Icon';
import { useIsEditing } from 'hooks';
import type { Field, SitecoreBlockProps } from 'models/sitecore';
import { getEditorMargin } from 'utils/business-logic/getEditorMargin';

import ContactHeading from './ContactHeading';

interface Props extends SitecoreBlockProps {
	fields?: {
		description?: Field<string>;
		heading?: Field<string>;
		icon?: {
			fields?: {
				iconName: Field<IconName>;
			};
		};
	};
}

export default function ContactHeadingBlock({ fields, params }: Props) {
	const isEditing = useIsEditing();

	if (!fields) {
		return null;
	}

	if (!isEditing && !fields.heading) {
		return null;
	}

	return (
		<ContactHeading
			className={getEditorMargin(params)}
			description={fields.description}
			heading={fields.heading}
			headingIcon={fields.icon?.fields?.iconName.value}
			headingLevel={params?.heading}
			id={params?.anchor}
		/>
	);
}
ContactHeadingBlock.displayName = 'ContactHeadingBlock';
